import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import lodash from "lodash";
import {
  STATO,
  CODICE_COLORE,
  ID_OSPEDALE,
  TIMESTAMP_TRIAGE,
  INIZIALI_PAZIENTE,
  LUOGO,
  PRESTAZIONI,
  LAST_EVENT,
  CODICE_DIALOG,
  ARGOMENTI_STATO_O_DIALOG,
  CODICE_MESSAGGIO,
  CODICE_EVENTO,
  FINE_EPISODIO_TIMESTAMP,
  LAST_UPDATE_FORMAT,
  FINE_EPISODIO_TIMESTAMP_DATE_FORMAT,
  FINE_EPISODIO_TIMESTAMP_TIME_FORMAT,
  ID_OSPEDALE_GALLIERA,
  ID_OSPEDALE_GASLINI,
  ID_OSPEDALE_EVANGELICO,
  ID_OSPEDALE_SAN_MARTINO,
  ID_OSPEDALE_IMPERIA,
  ID_OSPEDALE_SANREMO,
  ID_OSPEDALE_BORDIGHERA,
  ID_OSPEDALE_CAIRO,
  ID_OSPEDALE_ALBENGA,
  ID_OSPEDALE_SANTA_CORONA,
  ID_OSPEDALE_SAVONA,
  ID_OSPEDALE_PONTEDECIMO,
  ID_OSPEDALE_SESTRI,
  ID_OSPEDALE_VILLA_SCASSI,
  ID_OSPEDALE_LAVAGNA,
  ID_OSPEDALE_LA_SPEZIA,
  ID_OSPEDALE_LEVANTO,
  ID_OSPEDALE_SARZANA,
} from "./constants";
import {
  ENCOUNTER_COLORE_CHANGED,
  ENCOUNTER_LUOGO_CHANGED,
  ENCOUNTER_OSPEDALE_CHANGED,
  ENCOUNTER_PRESTAZIONI_CHANGED,
  ENCOUNTER_STATO_CHANGED,
  MESSAGGIO_RASSICURANTE,
} from "../language";
import {
  LogoAsl1Icon,
  LogoAsl2Icon,
  LogoAsl3Icon,
  LogoAsl4Icon,
  LogoAsl5Icon,
  LogoEvangelicoIcon,
  LogoGallieraIcon,
  LogoGasliniIcon,
  LogoSanMartinoIcon,
  LogoVillaScassiIcon,
} from "../../styles/images";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export const ottieniInformazioniEncounter = (data) => {
  let info = {
    [CODICE_EVENTO]: undefined,
    [ID_OSPEDALE]: undefined,
    [INIZIALI_PAZIENTE]: undefined,
    [LUOGO]: undefined,
    [STATO]: undefined,
    [CODICE_COLORE]: undefined,
    [PRESTAZIONI]: undefined,
    [LAST_EVENT]: undefined,
    [CODICE_DIALOG]: undefined,
    [ARGOMENTI_STATO_O_DIALOG]: undefined,
    [CODICE_MESSAGGIO]: undefined,
    [TIMESTAMP_TRIAGE]: undefined,
    [FINE_EPISODIO_TIMESTAMP]: undefined,
  };
  if (data) {
    info[CODICE_EVENTO] = data.encounter?.eventId;
    // Estrazione dati ps
    if (!lodash.isEmpty(data.hospital?.code)) info[ID_OSPEDALE] = data.hospital?.code + "0".repeat(8 - data.hospital?.code?.length);
    // Estrazione iniziali paziente
    info[INIZIALI_PAZIENTE] = data.patient?.family + data.patient?.name;
    // Estrazione dati location
    info[LUOGO] = data.location?.desc;
    // Estrazione stato
    info[STATO] = data.encounter?.status;
    // Estrazione codice triage
    info[CODICE_COLORE] = data.encounter?.color;
    // Estrazione messaggi dialog
    info[CODICE_DIALOG] = data.encounter?.dialog;
    // Estrazione messaggi utente
    info[CODICE_MESSAGGIO] = data.encounter?.message;
    // Estrazione eventuali argomenti per stato o messaggio
    info[ARGOMENTI_STATO_O_DIALOG] = data.encounter?.values;
    // Estrazione prestazioni
    info[PRESTAZIONI] = data.serviceRequests;
    // Estrazione informazione ultimo evento
    info[LAST_EVENT] = data.lastEvent;
    // Estrazione orario ingresso al ps
    const timestampAccessoPs = data.triage?.accesso;
    if (timestampAccessoPs) info[TIMESTAMP_TRIAGE] = dayjs(timestampAccessoPs).format(LAST_UPDATE_FORMAT);
    // Estrazione orario di fine episodio
    info[FINE_EPISODIO_TIMESTAMP] = data.encounter?.lastUpdated;
  }
  return info;
};

export const ottieniIconaPrestazione = (codicePrestazione) => {
  let icona = "";

  switch (codicePrestazione) {
    case "s-blood":
      icona = "analisi";
      break;
    case "s-imaging":
      icona = "diagnostica_immagini";
      break;
    case "s-consultations":
      icona = "accoglienza";
      break;
    case "l-evaluation":
      icona = "stetoscopio";
      break;
    case "l-reassessment":
      icona = "stetoscopio";
      break;
    case "l-nursing":
      icona = "rivalutazione";
      break;
    default:
      icona = "stetoscopio";
  }

  return icona;
};

export const ottieniLogoPs = (codicePs) => {
  let logo = null;
  if (codicePs === ID_OSPEDALE_SAN_MARTINO) logo = <LogoSanMartinoIcon />;
  else if (codicePs === ID_OSPEDALE_GALLIERA) logo = <LogoGallieraIcon />;
  else if (codicePs === ID_OSPEDALE_GASLINI) logo = <LogoGasliniIcon />;
  else if (codicePs === ID_OSPEDALE_EVANGELICO) logo = <LogoEvangelicoIcon />;
  else if (codicePs === ID_OSPEDALE_VILLA_SCASSI) logo = <LogoVillaScassiIcon />;
  else if ([ID_OSPEDALE_IMPERIA, ID_OSPEDALE_SANREMO, ID_OSPEDALE_BORDIGHERA].includes(codicePs)) logo = <LogoAsl1Icon />;
  else if ([ID_OSPEDALE_ALBENGA, ID_OSPEDALE_SANTA_CORONA, ID_OSPEDALE_CAIRO, ID_OSPEDALE_SAVONA].includes(codicePs)) logo = <LogoAsl2Icon />;
  else if ([ID_OSPEDALE_SESTRI, ID_OSPEDALE_PONTEDECIMO].includes(codicePs)) logo = <LogoAsl3Icon />;
  else if (codicePs === ID_OSPEDALE_LAVAGNA) logo = <LogoAsl4Icon />;
  else if ([ID_OSPEDALE_LA_SPEZIA, ID_OSPEDALE_LEVANTO, ID_OSPEDALE_SARZANA].includes(codicePs)) logo = <LogoAsl5Icon />;
  else logo = <></>;
  return logo;
};

export const checkEncounterChanges = (prevState, newState) => {
  const changes = [];
  const ospedaleChanged = !lodash.isEmpty(newState[ID_OSPEDALE]) && !lodash.isEqual(prevState[ID_OSPEDALE], newState[ID_OSPEDALE]);
  const luogoChanged = !lodash.isEmpty(newState[LUOGO]) && !lodash.isEqual(prevState[LUOGO], newState[LUOGO]);
  const statoChanged = !lodash.isEmpty(newState[STATO]) && !lodash.isEqual(prevState[STATO], newState[STATO]);
  const codiceColoreChanged = !lodash.isEmpty(newState[CODICE_COLORE]) && !lodash.isEqual(prevState[CODICE_COLORE], newState[CODICE_COLORE]);
  const { isChanged: prestazioniChanged, changes: prestazioniChanges } = checkPrestazioniChanged(prevState[PRESTAZIONI], newState[PRESTAZIONI]);
  const lastEventChanged = !lodash.isEmpty(newState[LAST_EVENT]) && !lodash.isEqual(prevState[LAST_EVENT], newState[LAST_EVENT]);

  if (ospedaleChanged) changes.push(ENCOUNTER_OSPEDALE_CHANGED);
  if (luogoChanged) changes.push(ENCOUNTER_LUOGO_CHANGED);
  if (statoChanged) changes.push(ENCOUNTER_STATO_CHANGED);
  if (codiceColoreChanged) changes.push(ENCOUNTER_COLORE_CHANGED);
  if (prestazioniChanged) changes.push(ENCOUNTER_PRESTAZIONI_CHANGED);

  const encounterHasChanged = ospedaleChanged || luogoChanged || statoChanged || codiceColoreChanged || prestazioniChanged;
  if (!encounterHasChanged && lastEventChanged) changes.push(MESSAGGIO_RASSICURANTE);

  return { isChanged: encounterHasChanged ? encounterHasChanged : lastEventChanged, changes, prestazioniChanges };
};

export const checkPrestazioniChanged = (prevState, newState) => {
  const changes = [];
  newState.forEach((prestazione) => {
    // prettier-ignore
    if (!lodash.isEqual(prestazione, prevState.find((el) => el.resId === prestazione.resId))) changes.push(prestazione.resId);
  });
  return { isChanged: !lodash.isEqual(prevState, newState), changes };
};

export const estraiParametriFineEpisodio = (data, config) => {
  let dischargeInfo = null;
  const fineEpisodio = dayjs(data[FINE_EPISODIO_TIMESTAMP]);
  const sei = fineEpisodio.set("h", 6).set("m", 0).set("s", 0).set("ms", 0);
  const venti = fineEpisodio.set("h", 20).set("m", 0).set("s", 0).set("ms", 0);
  // Verifico che il fine episodio sia compreso fra le 6:00:00 e le 20:00:00 -> discharge = fine episodio (+ n da config)
  if (fineEpisodio.isSameOrAfter(sei) && fineEpisodio.isSameOrBefore(venti)) dischargeInfo = fineEpisodio;
  // Verifico che il fine episodio sia compreso fra le 20:00:01 e le 23:59:59 -> discharge = 6 del mattino del giorno seguente (+ n da config)
  else if (fineEpisodio.isAfter(venti) && fineEpisodio.isSameOrBefore(fineEpisodio.endOf("d")))
    dischargeInfo = fineEpisodio.add(1, "d").set("h", 6).set("m", 0).set("s", 0).set("ms", 0);
  // Verifico che il fine episodio sia oltre le 24:00:00 -> discharge = 6 del mattino del giorno stesso (+ n da config)
  else if (fineEpisodio.isAfter(fineEpisodio.startOf("d"))) dischargeInfo = fineEpisodio.set("h", 6).set("m", 0).set("s", 0).set("ms", 0);
  return {
    endDate: fineEpisodio.format(FINE_EPISODIO_TIMESTAMP_DATE_FORMAT),
    endTime: fineEpisodio.format(FINE_EPISODIO_TIMESTAMP_TIME_FORMAT),
    dischargeInfoDate: dischargeInfo.add(config.expire, "h").format(FINE_EPISODIO_TIMESTAMP_DATE_FORMAT),
    dischargeInfoTime: dischargeInfo.add(config.expire, "h").format(FINE_EPISODIO_TIMESTAMP_TIME_FORMAT),
  };
};
